export interface EQSuggestion {
  uid: number;
  companyUID: number;
  status: number; // 0 - 미접수, 1 - 접수, 2 - 완료
  title: string;
  report: string;
  solution: string;
  url: string;
  type: number; // 0 - 오류, 1 - 질문, 2 - 건의
  imageFileName: string;
  otherFileName: string;
  isDeleted: boolean;
  entryDate: Date | string;
  modifyDate: Date | string;
  readDate: Date | string;
  completeDate: Date | string;

  // Non DB
  companyName: string;
  companyCode: string;
  base64Image: string;
  base64Other: string;
}

export const initializeSuggestion = (): EQSuggestion => {
  return {
    uid: 0,
    companyUID: 0,
    status: 0, // 0 - 미접수, 1 - 접수, 2 - 완료
    title: "",
    report: "",
    solution: "",
    url: "",
    type: 0, // 0 - 오류, 1 - 질문, 2 - 건의
    imageFileName: "",
    otherFileName: "",
    isDeleted: false,
    entryDate: new Date(),
    modifyDate: new Date(),
    readDate: new Date(),
    completeDate: new Date(),

    // Non DB
    companyName: "",
    companyCode: "",
    base64Image: "",
    base64Other: "",
  };
};

export interface suggestionParam {
  token: string;
  page?: number;
  rows?: number;
  status?: number;
  type?: number;
}

export const initializeSuggestionParam = (): suggestionParam => {
  return {
    token: "",
    page: 1,
    rows: 20,
    status: 0,
    type: 0,
  };
};

export const suggestionType = ["0 - 오류", "1 - 질문", "2 - 건의"];
